// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-nav-item.lit.scss INSTEAD!
import { css } from 'lit';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-nav-item-item-gap=1.5rem] - gap between navigation bar items
   */
  --sh-nav-item-item-gap: 1.5rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-transition=cubic-bezier(0.4, 0, 0.2, 1)] - speed of active stroke animation effect
   */
  --sh-nav-item-active-stroke-transition: cubic-bezier(0.4, 0, 0.2, 1);
  /* 
   * @cssprop [--sh-nav-item-height=3.5rem] - height of the nav item
   */
  --sh-nav-item-height: 3.5rem;
  /* 
   * @cssprop [--sh-nav-item-condensed-height=3rem] - height of the nav item in condensed mode
   */
  --sh-nav-item-condensed-height: 3rem;
  /* 
   * @cssprop [--sh-nav-item-label-min-width=1.5rem] - min-width of the nav item label
   */
  --sh-nav-item-label-min-width: 1.5rem;
  /* 
   * @cssprop [--sh-nav-item-slot-gap=0.25rem] - gap between label and slotted items
   */
  --sh-nav-item-slot-gap: 0.25rem;
  /* 
   * @cssprop [--sh-nav-item-label-line-height=1.25rem] - line-height of the nav item label
   */
  --sh-nav-item-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-nav-item-fade-width=2rem] - width of the fade effect on the left and right sides
   */
  --sh-nav-item-fade-width: 2rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-gap=0.75rem] - gap between the nav item label and the active-stroke
   */
  --sh-nav-item-active-stroke-gap: 0.75rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-gap-condensed=0.625rem] - gap between the nav item label and the active-stroke in condensed mode
   */
  --sh-nav-item-active-stroke-gap-condensed: 0.625rem;
  /* 
   * @cssprop [--sh-nav-item-right-slot-min-width=1rem] - min-width of the right slot
   */
  --sh-nav-item-right-slot-min-width: 1rem;
}

:host {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  max-width: var(--sh-public-nav-item-max-width, auto);
  height: 100%;
}

:host([disabled]) {
  pointer-events: none;
}

:host(:focus-visible) {
  outline: var(--focus-outline);
  outline-offset: -0.125rem;
}

.nav-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--color-text-inactive);
  text-decoration: none;
  gap: var(--sh-nav-item-slot-gap);
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  height: 100%;
}
:host([active]) .nav-item {
  color: var(--color-text-active);
}
:host([disabled]) .nav-item {
  color: var(--color-text-disabled);
}

slot[name=right] {
  min-width: var(--sh-nav-item-right-slot-min-width);
  display: flex;
  justify-content: center;
}

.nav-label {
  font: var(--title-1);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  min-width: var(--sh-nav-item-label-min-width);
  line-height: var(--sh-nav-item-label-line-height);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  cursor: pointer;
}

@media (hover: hover) and (pointer: fine) {
  :host(:hover) .nav-item,
  :host(:focus) .nav-item {
    color: var(--color-text-strong);
  }
}`;